<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";

  export let showAboutModal: boolean = false;
  export let closeModal: () => void;
  export let isRip: boolean = false;
</script>

<Modal bind:show={showAboutModal} fizzModal={true} medium={true} testId="about-deal-modal">
  <div class="layout-header-footer">
    <header class="fizz-modal-header">
      <h4 class="fizz-heading-4">About This Deal</h4>
      <a href={"#"} on:click|preventDefault={closeModal} class="fizz-modal-toggle fizz-modal-close">
        <Icon width="16" height="16" type="X" className="fizz-icon-16 fizz-text-brand" />
      </a>
    </header>
    <section class="fizz-modal-main fizz-text-medium fizz-flow-16">
      {#if isRip}
        <div>
          This is a mix RIP (Retailer Incentive Program) deal. Combine minimum number of products to
          qualify for the RIP. If you qualify for multiple RIPs for a single product, your
          distributor will determine the final RIP.
        </div>
      {:else}
        <div>
          This is a mix deal. Combine minimum number of products to achieve the deal. Discounts will
          be reflected in the cart. Below are a couple FAQ’s to help you out.
        </div>

        <div>
          <h4 class="fizz-heading-4">Can I apply more than one deal to an item?</h4>
          No. All deals can only be applied once per item.
        </div>

        <div>
          <h4 class="fizz-heading-4">What if I’m not seeing my standard deals?</h4>
          <div>
            Reach out to our <ChatWithSupportLink
              message="customer service team"
              bold={false}
              onClick={closeModal}
            /> and we can help you out.
          </div>
        </div>

        <div>
          <h4 class="fizz-heading-4">Where do these deals come from?</h4>
          Distributor partnership with Provi! These would be the deals your sales rep would already be
          mentioning to you.
        </div>
      {/if}
    </section>
  </div>
</Modal>
